module.exports = __webpack_public_path__ + "static/03-bf4ec3575f49782c6246026c6e4c60ee.png";